import React from "react";

const SearchTextInput = ({
  name,
  id = "",
  label,
  value,
  handleChange,
  placeholder = "",
  required = false,
  disabled = false,
  type,
  maxLength,
  cName,
  autoComplete,
}) => {
  return (
    <div>
      <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className="position-relative">
        <input
          type={type}
          className={`form-control mb-5px fs-5 ${cName}`}
          placeholder={placeholder}
          name={name}
          id={id}
          value={value}
          onChange={handleChange}
          required={required}
          disabled={disabled}
          maxLength={maxLength}
          autoComplete={autoComplete}
        />
        <i
          className="fa fa-search position-absolute searchicon"
        ></i>
      </div>
    </div>
  );
};

export default SearchTextInput;
